<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">{{i18n['purchaseOrderPaymentMethods']}}</div>
														<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">{{i18n['purchaseOrdersIntro']}}
														</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Search :appliedFilters="appliedFilters" :resourceSettings="resourceSettings" @createResource="createResource" @searchResource="loadResource()" />
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <Filters :filters="filters" :appliedFilters="appliedFilters" :resource="resource" />
											</v-col>
											<v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<v-btn color="primary" @click="loadResource()" block :class="`${arabic?'arFont':'enFont'}`">
													{{i18n.filter_results}}
												</v-btn>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Paging :resourceSettings="resourceSettings" :resource="resource" @createResource="createResource"
													@loadResource="loadResource" @pageByNumber="pageByNumber" />
											</v-col>
											<v-col cols="12" class=" py-0" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<v-row>
													<v-col cols="6" v-for="(item, index) in resource.data" :key="'item-'+ index" class="pa-2">
                            <v-card>
                              <v-card-text>
                                <div>
                                  <strong>
                                    {{ i18n['po_' + item.label] }}
                                  </strong>
                                </div>
                                <v-row class="align-center">
                                  <v-col cols="12" md="12" class="py-0" v-for="(field, f) in fields" :key="'field-'+f">
                                    <Field :field="field" :item="item" :index="f" />
                                  </v-col>
                                </v-row>
                                <div class="mt-2">
                                  <v-btn type="submit" color="success" :loading="loading" v-if="item.id" @click="update(item)">{{ i18n["update"] }}</v-btn>
                                </div>
                              </v-card-text>
                            </v-card>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Paging from '../components/Paging.vue';
import Item from './PurchaseOrder/Item.vue'
import Filters from '../components/Filters.vue'
import Search from '../components/Search.vue'
import Field from '@/components/Field.vue';

export default {
	components: {
		Paging,
    Item,
    Filters,
		Search,
    Field
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				createResource: true,
				resourceName: null,
				search: true,
				create: true,
				pagination: true,
			},
			resource: {},
			filters:[
				{type:'switch', label:'is_not_active', key:'is_not_active'},
			],
			appliedFilters:{},
      fields: [
        {
          name: "ar",
          type: 'text',
          label: 'ar_language',
          info: { en: '', ar: '' },
        },
        {
          name: "en",
          type: 'text',
          label: 'en_language',
          info: { en: '', ar: '' },
        },
        {
          name: "is_active",
          type: 'switch',
          label: 'is_active',
          info: { en: '', ar: '' },
        },
        {
          name: "details",
          type: 'editor',
          label: 'po_payment_method_details',
          info: { en: '', ar: '' },
        },
      ],
			search:null,
		}
	},
	methods: {
    async update(resource) {
			this.loading = true
			await this.$store.dispatch('putResource', { resource: '/po-payment-methods/' + resource.id, value: {...resource} })
      await this.loadResource()
			this.loading = false
		},
		async createResource(){
      
    },
		clipboardSuccessHandler({ value, event }) {
			this.$emit('clipboardSuccessHandler', { value, event });
		},
		async loadResource(page = 1) {
			this.loading = true
			this.resource = await this.$store.dispatch('getResource', { resource: `/po-payment-methods?page=${page}`, filters:this.appliedFilters })
			this.loading = false
		},
		async pageByNumber(page) {
			await this.loadResource(page)
		},
	},
	computed: {
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
		master() {
      return this.$store.state.user.role == 'master';
    },
		
	},
	async mounted(page = 1) {
		await this.loadResource()
	}
}
</script>